
import React from 'react';
import { Link } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

export const AdminLink: React.FC = () => {
  const isMobile = useIsMobile();
  
  return (
    <Link 
      to="/admin" 
      className="bg-gradient-to-r from-blue-500 to-sky-500 text-white px-2 py-1 rounded-md hover:from-blue-600 hover:to-sky-600 transition-all shadow-md flex items-center gap-1 font-medium"
    >
      <LogIn size={isMobile ? 12 : 14} className="stroke-[2.5]" />
      <span>Admin</span>
    </Link>
  );
};
